<template>
    <div class="landing-page">
        <div class="page-bg" :style="{'background-image': `url('${$store.getters.getBgLanding}')`}"></div> 
        <div class="naos-logo" :style="{'background-image': `url('${$store.getters.getLogoNao}')`}"></div>
        <div class="bioderma-logo" :style="{'background-image': `url('${$store.getters.getLogoBioderma}')`}"></div>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
import Account from "@/helper/AccountHelper.js";
import Util from "@/helper/Utility.js";
import CacheHelper from "@/helper/CacheHelper.js";
import LineFunction from "@/helper/facade/LineFunction.js";
//mixin
import ModalMixin from "@/mixin/ModalMixin.js";
import AccountMixin from "@/mixin/AccountMixin.js"
import PDPAMixin from "@/mixin/PDPAMixin.js";
//service
import BzbsAuth from "@/core/Account/service/BzbsAuth.js";

export default {
    name: "LoginLine",
    mixins: [ModalMixin, AccountMixin, PDPAMixin],
    data: function() {
        return {
            liffId: null
        };
    },
    created: function() {
        this.initLiff();
    },
    methods: {
        initLiff: function() {
            var lineFunction = new LineFunction();
            this.liffId = lineFunction.getLiffId();
            //this.liffId = '1655640513-nD8g5Y6q'; //for test localhost
            //this.liffId = '1655767597-WNALg1zg'; //stg

            lineFunction.init(this.liffId).then(() => {
                var currentUrl = window.location.href;
                if (lineFunction.isLogin()) {
                    if (lineFunction.isTokenExpire()) {
                        lineFunction.logout();
                        lineFunction.login(currentUrl);
                        return;
                    }

                    var idToken = lineFunction.getIdToken();
                    var cache = new CacheHelper('session');
                    cache.setCache('LineIdToken', idToken);

                    if (idToken != null) {
                        this.loginBzbs(idToken);
                    } else {
                        alert('Something error');
                    }
                } else {
                    lineFunction.login(currentUrl);
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        loginBzbs: async function(idToken) {
            var user = await this.apiLoginLine(idToken);
            if(user){
                var targetPage = this.$route.query.target_page;
                await this.apiGetProfile();
                await this.getPDPAConsent(targetPage);
            }
        },
        apiLoginLine: async function(idToken) {
            return new Promise((resolve, reject) => {
                this.loadingModal.show();
                BzbsAuth.apiLoginLine(idToken).subscribe((data) => {
                    this.loadingModal.hide();
                    Account.setLogin(data);
                    resolve(data);
                }, (err) => {
                    this.loadingModal.hide();
                    this.redirectNotLogin();
                    //window.location.replace('/login');
                    reject(err);
                });
            });
        },
        apiGetProfile: async function() {
            return new Promise((resolve, reject) => {
                this.loadingModal.show();
                Account.apiGetProfile().then(() => {
                    this.loadingModal.hide();
                    resolve();
                }).catch((err) => {
                    this.loadingModal.hide();
                    this.redirectNotLogin();
                    //window.location.replace('/login');
                    reject(err);
                });
            })
        },
        redirectNotLogin: function() {
            var target_page = this.$route.query.target_page;
            var page = '';
            var code = '';
            var cache = new CacheHelper('session');

            if(target_page){
                var targetPage = '';
                    targetPage = target_page.split('/');
                    if(targetPage.length > 1){
                        page = targetPage[0];
                        code = targetPage[1];
                    }else{
                        page = targetPage[0];
                    }
            }

            switch (page) {
                case "register":
                    window.location.replace('/login');
                    break;
                case "home":
                    window.location.replace('/');
                    break;
                case "point":
                    window.location.replace('/login');
                    break;
                case "reward":
                    if(code){
                        cache.setCache('isFromBDM', true);
                        window.location.replace('/reward/'+code);
                    }
                    break;
                case "rewards":
                    if(code){
                        cache.setCache('isFromBDM', true);
                        window.location.replace('/rewards/'+code);
                    }else{
                        cache.setCache('isFromBDMList', true);
                        window.location.replace('/rewards');
                    }
                    break;
                case "qr":
                    window.location.replace('/login');
                    break;
                case "productpoint":
                    cache.setCache('isFromBDMPoint', true);
                    window.location.replace('/point/guide');
                    break;
                case "getfriend":
                    cache.setCache('friendcode', code);
                    window.location.replace('/login');
                    break;
                default:
                    window.location.replace('/login');
                    break;
            }
        },
        redirectLogin: function() {
            var target_page = this.$route.query.target_page;
            var page = '';
            var code = '';
            var cache = new CacheHelper('session');

            if(target_page){
                var targetPage = '';
                    targetPage = target_page.split('/');
                    if(targetPage.length > 1){
                        page = targetPage[0];
                        code = targetPage[1];
                    }else{
                        page = targetPage[0];
                    }
            }

            switch (page) {
                case "register":
                    window.location.replace('/');
                    break;
                case "home":
                    window.location.replace('/');
                    break;
                case "point":
                    window.location.replace('/point');
                    break;
                case "reward":
                    if(code){
                        cache.setCache('isFromBDM', true);
                        window.location.replace('/reward/'+code);
                    }
                    break;
                case "rewards":
                    if(code){
                        cache.setCache('isFromBDMList', true);
                        window.location.replace('/rewards/'+code);
                    }else{
                        cache.setCache('isFromBDMList', true);
                        window.location.replace('/rewards');
                    }
                    break;
                case "qr":
                    if(code){
                        cache.setCache('BDMCode', code);

                        window.location.replace('/point');
                    }else{
                        window.location.replace('/point');
                    }
                    break;
                case "productpoint":
                    cache.setCache('isFromBDMPointLogin', true);
                    window.location.replace('/point/guide');
                    break;
                default:
                    if (Util.isEmptyStr(target_page)) {
                        window.location.replace('/');
                    } else {
                        window.location.replace('/'+target_page);
                    }
                    break;
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.landing-page {
    max-width: 500px;
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: #f3fafc;
    margin: auto;
    left: 0;
    right: 0;

    .page-bg {
        max-width: 500px;
        width: 100%;
        height: 100%;
        background-color: #f3fafc;
        background-repeat: no-repeat;
        background-position: top center;
        background-size: 100%;
        position: fixed;
        z-index: 0;
        top: 0;
        left: 0;
        right: 0;
        margin: auto;
    }
    .naos-logo {
        width: 136px;
        height: 100%;
        background-repeat: no-repeat;
        background-position: top center;
        background-size: 100%;
        position: fixed;
        z-index: 0;
        top: 18px;
        left: 0;
        right: 0;
        margin: auto;
    }
    .bioderma-logo {
        width: 220px;
        height: 100%;
        background-repeat: no-repeat;
        background-position: top center;
        background-size: 100%;
        position: fixed;
        z-index: 0;
        top: 61px;
        left: 0;
        right: 0;
        margin: auto;
    }
}
</style>
